import React, { useState } from 'react';
import {
  Box, Typography, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Select, MenuItem, TextField, Button, Snackbar
} from '@mui/material';

const initialData = [
  {
    id: 1,
    legajo: '10234',
    nombre: 'M. Sosa',
    puesto: 'QA SSR',
    area: 'QA',
    lider: 'L. Ruiz',
    puntajeOriginal: 3,
    puntajeCalibrado: 3,
    comentario: '',
    calibrado: false,
  },
  {
    id: 2,
    legajo: '10988',
    nombre: 'R. Gil',
    puesto: 'Dev Jr',
    area: 'Tech',
    lider: 'J. Mora',
    puntajeOriginal: 4,
    puntajeCalibrado: 4,
    comentario: '',
    calibrado: false,
  },
];

export default function CalibrationDashboard() {
  const [rows, setRows] = useState(initialData);
  const [showSnackbar, setShowSnackbar] = useState(false);

  const handlePuntajeChange = (id, newValue) => {
    setRows(prev =>
      prev.map(row =>
        row.id === id
          ? { ...row, puntajeCalibrado: newValue }
          : row
      )
    );
  };

  const handleComentarioChange = (id, newValue) => {
    setRows(prev =>
      prev.map(row =>
        row.id === id
          ? { ...row, comentario: newValue }
          : row
      )
    );
  };

  const handleGuardar = () => {
    const errores = rows.filter(
      row => row.puntajeOriginal !== row.puntajeCalibrado && row.comentario.trim() === ''
    );

    if (errores.length > 0) {
      alert('Falta comentario en evaluaciones con cambio de puntaje.');
      return;
    }

    const actualizados = rows.map(row => ({
      ...row,
      calibrado: true,
    }));

    console.log('✅ Evaluaciones guardadas:', actualizados);
    setRows(actualizados);
    setShowSnackbar(true);
  };

  return (
    <Box p={4}>
      <Typography variant="h4" gutterBottom>
        Calibrar Evaluaciones
      </Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Legajo</TableCell>
              <TableCell>Nombre</TableCell>
              <TableCell>Puesto</TableCell>
              <TableCell>Área</TableCell>
              <TableCell>Líder</TableCell>
              <TableCell>Puntaje Original</TableCell>
              <TableCell>Puntaje Calibrado</TableCell>
              <TableCell>Comentario</TableCell>
              <TableCell>Estado</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(row => (
              <TableRow key={row.id}>
                <TableCell>{row.legajo}</TableCell>
                <TableCell>{row.nombre}</TableCell>
                <TableCell>{row.puesto}</TableCell>
                <TableCell>{row.area}</TableCell>
                <TableCell>{row.lider}</TableCell>
                <TableCell>{row.puntajeOriginal}</TableCell>
                <TableCell>
                  <Select
                    value={row.puntajeCalibrado}
                    onChange={(e) => handlePuntajeChange(row.id, e.target.value)}
                  >
                    {[1, 2, 3, 4, 5].map(num => (
                      <MenuItem key={num} value={num}>{num}</MenuItem>
                    ))}
                  </Select>
                </TableCell>
                <TableCell>
                  <TextField
                    value={row.comentario}
                    onChange={(e) => handleComentarioChange(row.id, e.target.value)}
                    placeholder="Comentario de calibración"
                    fullWidth
                    multiline
                    size="small"
                  />
                </TableCell>
                <TableCell>
                  {row.calibrado ? '✅ Calibrado' : '🟠 Pendiente'}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box mt={3}>
        <Button variant="contained" color="primary" onClick={handleGuardar}>
          Guardar Cambios
        </Button>
      </Box>
      <Snackbar
        open={showSnackbar}
        autoHideDuration={3000}
        onClose={() => setShowSnackbar(false)}
        message="Cambios guardados correctamente"
      />
    </Box>
  );
}
